export const originalProjectTitle= "Original Projects"
export const originalProjectsList = [
    {
        label: 'Anime Style Character Sheets',
        path:'/pages/original-projects/anime-style-character-sheets',
        component:'AnimeCharSheets',
        previewimage:[
            {
                imageName:'Anime Style Character Sheets',
                imagePath:'/assets/images/projects/animeOCs/charsheet-zolinMerlo.png',
                projectPath:'/pages/original-projects/anime-style-character-sheets',
            }
        ],
        projectimages:[
            {
                imageName:'Zolin Merlo Chavez',
                imagePath:'/assets/images/projects/animeOCs/charsheet-zolinMerlo.png',
                imageDescription:'This is Zolin Merlo Chavez. A sixteen year old human-sprite mixed kid. The story I have for him, is that he has to balance doing odd jobs for a benefactor his late father contracted him into while keeping that a secret from his family and friends.'
            },
            {
                imageName:'Mazatl Merlo Chavez',
                imagePath:'/assets/images/projects/animeOCs/charsheet-mazatlMerlo.png',
                imageDescription:'This is Mazatl Merlo Chavez. He\'s nine years old and is Zolin\'s little brother. He\'s also a human-sprite mixed kid. He managed to inherit the shape shifting gene from his mother\'s side, so he uses it to mess with his family.'
            }
        ]
    },
    {
        label:'Meet My Characters',
        path:'/pages/original-projects/meet-my-ocs',
        component:'MeetMyChars',
        previewimage:[
            {
                imageName:'Meet My Characters',
                imagePath:'/assets/images/projects/myocs/throuple1.png',
                projectPath:'/pages/original-projects/meet-my-ocs',
            }
        ],
        projectimages:[
            {
                imageName:'',
                imagePath:'/assets/images/projects/',
                imageDescription:''
            },
        ]
    },
     {
        label:'My Earring Collection', 
        path:'/pages/original-projects/my-earring-collection',
        component:'EarringCollection',
        previewimage:[
            {
                imageName:'My Earring Collection', 
                imagePath:'/assets/images/projects/earrings/erdutza-2sig.png',
                projectPath:'/pages/original-projects/my-earring-collection',
            }
        ],
        projectimages:[
            {
                imageName:'Erdutza wearing Kikay',
                imagePath:'/assets/images/projects/earrings/erdutza-2sig.png',
                imageDescription:'This is Erdutza Merlo drawn in a more anime-esque style wearing earrings I own from kikay.shop.'
            },
            {
                imageName:'Zolin wearing Kikay',
                imagePath:'/assets/images/projects/earrings/matchaChains-aaronMerlo.png',
                imageDescription:'This is Zolin Merlo wearing the matcha chains, also by kikay (I also own these).'
            },
            {
                imageName:'Beatríz wearing lileekaycreations',
                imagePath:'/assets/images/projects/earrings/beatriz-2sig.png',
                imageDescription:'This is Beatriz Merlo wearing star shakers by lileekaycreations.'
            }
        ]
    },
    {
        label:'Vampire Cards',
        path:'/pages/original-projects/vampire-cards',
        component:'VampireCards',
        previewimage:[
            {
                imageName:'Vampire Cards Series',
                imagePath:'/assets/images/projects/vampire-cards/2diamonds-withsig.png',
                projectPath:'/pages/original-projects/vampire-cards'
            }
        ],
         projectimages:[
            {
                imageName:'2 of diamonds',
                imagePath:'/assets/images/projects/vampire-cards/2diamonds-withsig.png',
                imageDescription:'This is part of a series of making a vampire themed playing card set. It\'s an ongoing project that I come back to sometimes'
            },
            {
                imageName:'4 of diamonds',
                imagePath:'/assets/images/projects/vampire-cards/4diamonds-withsig.png',
                imageDescription:'This is the 4 of diamonds in the vampire card series.'
            },
            {
                imageName:'4 of hearts',
                imagePath:'/assets/images/projects/vampire-cards/4hearts-withsig.png',
                imageDescription:'This is the 4 of hearts in the vampire cards series'
            },
            {
                imageName:'4 of spades',
                imagePath:'/assets/images/projects/vampire-cards/4spades-withsig.png',
                imageDescription:'This is the 4 of spades in the vampire cards series'
            },
            {
                imageName:'5 of diamonds',
                imagePath:'/assets/images/projects/vampire-cards/5diamonds-withsig.png',
                imageDescription:'This is the 5 of diamonds in the vampire cards series'
            },
            {
                imageName:'9 of diamonds',
                imagePath:'/assets/images/projects/vampire-cards/9diamonds-withsig.png',
                imageDescription:'This is the 9 of diamonds in the vampire cards series'
            },
            {
                imageName:'Ace of Diamonds',
                imagePath:'/assets/images/projects/vampire-cards/Adiamonds-withsig.png',
                imageDescription:'This is the ace of diamonds in the vampire cards series'
            },
            {
                imageName:'Queen of hearts',
                imagePath:'/assets/images/projects/vampire-cards/Qhearts-withsig.png',
                imageDescription:'This is the queen of hearts in the vampire cards series'
            }
         ]
    },
    {
        label:'Starry Night Ball', 
        path:'/pages/original-projects/starry-night-ball',
        component:'StarryNightBall',
        previewimage:[
            {
                imageName:'Starry Night Ball',
                imagePath:'/assets/images/projects/starrynight/starrynight-ball.png',
                projectPath:'/pages/original-projects/starry-night-ball',
            }
        ],
        projectimages:[
            {
                imageName:'Starry Night Ball',
                imagePath:'/assets/images/projects/starrynight/starrynight-ball.png',
                imageDescription:'This was part of an instagram trend I enjoyed.'
            },
        ]
    },
    {
        label:'Madness in a Bottle',
        path:'/pages/original-projects/madness-in-a-bottle',
        component:'MadnessBottle',
        previewimage:[
            {
                imageName:'Madness in a Bottle',
                imagePath:'/assets/images/projects/madness-bottle/NisabaMomus.png',
                projectPath:'/pages/original-projects/madness-in-a-bottle',
            }
        ],
        projectimages:[
            {
                imageName:'Péronne',
                imagePath:'/assets/images/projects/madness-bottle/Gula.png',
                imageDescription:'This goddess was based on a fanfiction character I had written based on a Greek mythology centered show I used to watch as a kid. I wanted to write that story into my own original one outside the franchise the fan fiction was based on. And she came out of it first. She\'s based on my interpretation of Melinoë, goddess of ghosts. Her name is Péronne, she is the goddess of witchcraft and ghosts. Her old name is Gula'
            },
            {
                imageName:'René',
                imagePath:'/assets/images/projects/madness-bottle/Enki.png',
                imageDescription:'He is based on my fanfiction version of Zagreus, god of rebirth. Here is name is René, god of travelers and rebirth. His old name is Enki',
            },
            {
                imageName:'Nisaba',
                imagePath:'/assets/images/projects/madness-bottle/Nisaba.png',
                imageDescription:'This one is based on Momus, god of mockery and satirical criticism. His name is Nisaba. Here he is the god of writers and mockery.',
            },
            {
                imageName:'Nisaba revised',
                imagePath:'/assets/images/projects/madness-bottle/NisabaMomus.png',
                imageDescription:'Another rendition of Nisaba. I wanted to use him to enter a contest about the greek gods so I named this piece Momus, but used my original design of Nisaba (had him in the arsenal anyway). The contest didn\'t pan out but I\'m proud of how the piece turned out. '
            }
        ]
    },
    {
        label:'Self Portrait in Purple', 
        path: '/pages/original-projects/self-portrait-in-purple',
        component:'SelfPortraitPurple',
        previewimage:[
            {
                imageName:'Self Portrait in Purple',
                imagePath:'/assets/images/projects/self-portrait.webp',
                projectPath:'/pages/original-projects/self-portrait-in-purple',
            }
        ],
        projectimages:[
            {
                imageName:'Self Portrait in Purple',
                imagePath:'/assets/images/projects/self-portrait.webp',
                imageDescription:'This was a style exercize basically.'
            },
        ]
    },
    {
        label:'Self Portrait Movie Study', 
        path: '/pages/original-projects/self-portrait-spiderverse',
        component:'SpiderverseSelfPortrait',
        previewimage:[
            {
                imageName:'Self Portrait Movie Study',
                imagePath:'/assets/images/projects/spiderverse/maindrawing.png',
                projectPath: '/pages/original-projects/self-portrait-spiderverse',
            }
        ],
        projectimages:[
            {
                imageName:'Self Portrait Movie Study',
                imagePath:'/assets/images/projects/spiderverse/maindrawing.png',
                imageDescription:'This started off as an instagram trend, but it turned into a great opportunity to study a unique style from one of the biggest movie series in recent years.'
            },
        ]
    },
    {
        label: 'My Mindscape, Art Squared Contest', 
        path:'/pages/original-projects/my-mindscape',
        component:'ArtSquaredContest',
        previewimage:[
            {
                imageName:'My Mindscape, Art Squared Contest',
                imagePath:'/assets/images/projects/artsquared/ArtSquaredContest-display.png',
                projectPath: '/pages/original-projects/my-mindscape',
            }
        ],
        projectimages:[
            {
                
                imageName:'My Mindscape, Art Squared Contest',
                imagePath:'/assets/images/projects/artsquared/ArtSquaredContest-display.png',
                imageDescription:'This was my entry for a contest.'
            },
        ]
    },
    {
        label:'Public Figure Portraits',
        path:'/pages/original-projects/public-figure-portraits',
        component:'PublicFigurePortraits',
        previewimage:[
            {
                imageName:'Public Figure Portraits',
                imagePath:'/assets/images/projects/publicfigureportraits/kevin-kreider.png',
                projectPath: '/pages/original-projects/public-figure-portraits',
            }
        ],
        projectimages:[
            {
                imageName:'Oscar Isaac',
                imagePath:'/assets/images/projects/publicfigureportraits/oscar-isaac.png',
                imageDescription:'Actor Oscar Isaac'
            },
            {
                imageName:'Amazin Le Thi',
                imagePath:'/assets/images/projects/publicfigureportraits/amazinLeThi.png',
                imageDescription:'Olympian and LGBTQ activist Amazin Le Thi'
            },
            {
                imageName:'Kevin Kreider',
                imagePath:'/assets/images/projects/publicfigureportraits/kevin-kreider.png',
                imageDescription:'Social Media Star Kevin Kreider'
            },
        ]
    },
    {
        label:'Hole face', 
        path:'/pages/original-projects/hole-face',
        component:'HoleFace',
        previewimage:[
            {
                imageName:'Hole face',
                imagePath:'/assets/images/projects/holeface/hole-face.png',
                projectPath:'/pages/original-projects/hole-face',
            }
        ],
        projectimages:[
            {
                imageName:'Hole face Final',
                imagePath:'/assets/images/projects/holeface/hole-face.png',
                imageDescription:'This was an experiment to test out a style reminiscent to those 60s physchedelic posters. I used my sister as a model.'
            },
            {
                imageName:'Hole face Sketch',
                imagePath:'/assets/images/projects/holeface/sketch.jpg',
                imageDescription:'This is the sketch for the hole face project'
            }
         ]
    },
    {
        label:'Chili Girl Concept Collaboration',
        path:'/pages/original-projects/chili-girl-concept-collab',
        component:'ChiliGirl',
        previewimage:[
            {
                imageName:'Chili Girl Collab Project',
                imagePath:'/assets/images/projects/ella-collab/foottown.jpg',
                projectPath:'/pages/original-projects/chili-girl-concept-collab'
            }
        ],
        projectimages:[
            {
                imageName:'Chili-girl',
                imagePath:'/assets/images/projects/ella-collab/chili-board.jpg',
                imageDescription:'This first board was meant to depict the main character arriving to the big (food themed) city.'
            },
            {
                imageName:'Food-Town',
                imagePath:'/assets/images/projects/ella-collab/foottown.jpg',
                imageDescription:'This concept art was a depiction of the big city our main character was going to venture off to.'
            },
            {
                imageName:'Kitchen',
                imagePath:'/assets/images/projects/ella-collab/kitchen.jpg',
                imageDescription:'This was based off some reasearch on what industrial kitchens looked like. I modeled a rough 3d replica of what the layout would look like to get a better reference on lighting.'
            }
        ]
    },
    {
        label:'Layouts and Backgrounds',
        path:'/pages/original-projects/layouts-backgrounds',
        component:'Backgrounds',
        previewimage:[
            {
                imageName:'Layouts and backgrounds',
                imagePath:'/assets/images/projects/layouts/ruby-fanart.jpg',
                projectPath:'/pages/original-projects/layouts-backgrounds',
            }
        ],
        projectimages:[
            {
                imageName:'Cliffside 01',
                imagePath:'/assets/images/projects/layouts/layout3.jpg',
                imageDescription:'This piece was part of a backgrounds for animation class.'
            },
            {
                imageName:'Cliffside 02',
                imagePath:'/assets/images/projects/layouts/layout4.jpg',
                imageDescription:'This piece was for that same backgrounds for animation class. We were supposed to draw an existing layout project from a differnet point of view.'
            },
            {
                imageName:'Cliffside 02 but at night',
                imagePath:'/assets/images/projects/layouts/layout5.jpg',
                imageDescription:'This piece for the same background for animation class was a lighting exercise to see if we could visualize the same backround at night/day (depending on when the first was depicted).'
            },
            {
                imageName:'Panning Cliffside Village',
                imagePath:'/assets/images/projects/layouts/panlayout.jpg',
                imageDescription:'Some layouts are made for long panning shots so the dimensions of the piece are less standard. This is what this piece was teaching us for the backgrounds for animation class.'
            },
            {
                imageName:'Ruby Gloom Layout Style Exercise',
                imagePath:'/assets/images/projects/layouts/ruby-fanart.jpg',
                imageDescription:'This exercise (still for the background for animation class) had us imitate the layout style of an existing IP but using a perspective style the show does not use. This taught us less standard perspective use and how to imitate an existing drawing style (which is an important industry skill for artists first starting in the industry).'
            },
            {
                imageName:'Ruby Gloom Layout Style Exercise',
                imagePath:'/assets/images/projects/layouts/ruby2-fanart.jpg',
                imageDescription:'This is another perspective and style imitation exercise using an existing IP. This has an above point of view.'
            },
            {
                imageName:'Ruby Gloom Layout Style Exercise',
                imagePath:'/assets/images/projects/layouts/ruby3-fanart.jpg',
                imageDescription:'This was another version of the same perspective and style imitation exercise but with no perspective.'
            }
        ]
    },
    {
        label:'NOLA Photo Study', 
        path:'/pages/original-projects/nola-photo-study',
        component:'NolaStudy',
        previewimage:[
            {
                imageName:'NOLA photo study',
                imagePath:'/assets/images/projects/NOLA/NOLA-ghostsBG-BIG02.png',
                projectPath:'/pages/original-projects/nola-photo-study',
            }
        ],
        projectimages:[
            {
                imageName:'NOLA reference picture',
                imagePath:'/assets/images/projects/NOLA/NOLA_001_referencePic.png',
                imageDescription:'The reference picture from a trip to New Orleans'
            },
            {
                imageName:'NOlA linework',
                imagePath:'/assets/images/projects/NOLA/NOLA_002_Linework.png',
                imageDescription:'Linework to experiement with style (what to keep what to omit)'
            },
            {
                imageName:'NOLA colour flats',
                imagePath:'/assets/images/projects/NOLA/NOLA_003_colour.png',
                imageDescription:'Flat colours that capture how colourful NOLA is'
            },
            {
                imageName:'NOLA lighting',
                imagePath:'/assets/images/projects/NOLA/NOLA_004_shading01.png',
                imageDescription:'The lighting layer for the project'
            },
            {
                imageName:'NOLA lighting on colour flats',
                imagePath:'/assets/images/projects/NOLA/NOLA_004_shading02.png',
                imageDescription:'What does the lighting look like over the colourful buildings'
            },
            {
                imageName:'NOLA shading with linework',
                imagePath:'/assets/images/projects/NOLA/NOLA_005_shadingWLinework.png',
                imageDescription:''
            },
            {
                imageName:'NOLA photo study Final',
                imagePath:'/assets/images/projects/NOLA/NOLA-ghostsBG-BIG02.png',
                imageDescription:'My sister Anh was drawing a background from a vacation photo with added ghosts and I thought it would be a fun way to study layouts and lighting.s'
            }
         ]
    },
    {
        label:'Delivery for the Baker', 
        path:'/pages/original-projects/delivery-for-the-baker',
        component:'Delivery',
        previewimage:[
            {
                imageName:'Delivery for the Baker', 
                imagePath:'/assets/images/projects/deliverybaker/bgs/bgroom9_SaintCloud.png',
                projectPath:'/pages/original-projects/delivery-for-the-baker',
            }
        ],
        projectimages:[
            {
                imageName:'Mattsdotter house',
                imagePath:'/assets/images/projects/deliverybaker/bgs/bgroom3_Mattsdotter.png',
                imageDescription:'This is one of the NPC houses in the game.'
            },
            {
                imageName:'Erasmus house',
                imagePath:'/assets/images/projects/deliverybaker/bgs/bgroom8_Erasmus.png',
                imageDescription:'This is another NPC house you deliver cakes to.'
            },
            {
                imageName:'Saint Cloud House',
                imagePath:'/assets/images/projects/deliverybaker/bgs/bgroom9_SaintCloud.png',
                imageDescription:'This is an NPC house for more people you have to deliver cakes to. To see more of these lovely backgrounds, download my game on itch.io once it is finished.'
            },
        ]
    },
    {
        label:'Millicent Lost Her Eye', 
        path:'/pages/original-projects/millicent-lost-her-eye',
        component:'Millicent',
        previewimage:[
            {
                imageName:'Millicent Lost Her Eye', 
                imagePath:'/assets/images/projects/millie/main-menu-bg01.png',
                projectPath:'/pages/original-projects/millicent-lost-her-eye',
            }
        ],
        projectimages:[
            {
                imageName:'Main menu picture', 
                imagePath:'/assets/images/projects/millie/main-menu-bg01.png',
                imageDescription:'This is the illustration on the main menu. What you first see when you load up the game. I tried to capture an eerie vibe while still keeping some cuteness.'
            },
            {
                imageName:'The bedroom', 
                imagePath:'/assets/images/projects/millie/bgs/bedroom.png',
                imageDescription:'The first room you find yourself in, when starting the game. How do you get out?'
            },
            {
                imageName:'The dining room.', 
                imagePath:'/assets/images/projects/millie/bgs/diningroom.png',
                imageDescription:'The dining room of the house you find yourself in. Where are the puzzles here?'
            },
            {
                imageName:'The lobby', 
                imagePath:'/assets/images/projects/millie/bgs/lobby.png',
                imageDescription:'The lobby of the house you find yoursel in. Where do you go now?'
            },
            {
                imageName:'The office', 
                imagePath:'/assets/images/projects/millie/bgs/office.png',
                imageDescription:'The office of the house you find yourself in. What could be useful here?'
            },
        ]
    },
    {
        label:'Time To Talk', 
        path:'/pages/original-projects/time-to-talk',
        component:'TimeTalk',
        previewimage:[
            {
                imageName:'Time To Talk', 
                imagePath:'/assets/images/projects/time-to-talk/main-menu-coverupdate.png',
                projectPath:'/pages/original-projects/time-to-talk',
            }
        ],
        projectimages:[
            {
                imageName:'Main menu splash page', 
                imagePath:'/assets/images/projects/time-to-talk/main-menu-coverupdate.png',
                imageDescription:'This is the main menu illustration for the game.'
            },
            {
                imageName:'Aitor\'s Office', 
                imagePath:'/assets/images/projects/time-to-talk/aitoroffice1.png',
                imageDescription:'Aitor\'s Office is one of the scenes you get if you play as Daniel.'
            },
            {
                imageName:'Alleyway', 
                imagePath:'/assets/images/projects/time-to-talk/alleyway.png',
                imageDescription:'This is alleyway you get if you play as Ben.'
            },
            {
                imageName:'Ben Good End', 
                imagePath:'/assets/images/projects/time-to-talk/ben-goodend1.png',
                imageDescription:'A good end you get if you play as Ben.'
            },
            {
                imageName:'Ben Good End 2', 
                imagePath:'/assets/images/projects/time-to-talk/ben-goodend2.png',
                imageDescription:'Another ending you can get if you play as ben.'
            },
            {
                imageName:'City Café', 
                imagePath:'/assets/images/projects/time-to-talk/city-cafe.png',
                imageDescription:'A café you can get if you play as Dan.'
            },
            {
                imageName:'Cityscape', 
                imagePath:'/assets/images/projects/time-to-talk/cityscape-draw.png',
                imageDescription:'You get this view if you play as Ben.'
            },
            {
                imageName:'Collar Grab', 
                imagePath:'/assets/images/projects/time-to-talk/collargrab1.png',
                imageDescription:'A scene you get if you play as Ben.'
            },
            {
                imageName:'Daniel notices a job.', 
                imagePath:'/assets/images/projects/time-to-talk/Danielnoticejob.png',
                imageDescription:'If you play as Daniel, you get this scene.'
            },
            {
                imageName:'Daniel\'s office', 
                imagePath:'/assets/images/projects/time-to-talk/danoffice.png',
                imageDescription:'I don\'t really remember where you get this one.'
            },
            {
                imageName:'Edge of rooftop', 
                imagePath:'/assets/images/projects/time-to-talk/edgerooftop.png',
                imageDescription:'Ben notices something, while gazing out from the edge of the rooftop'
            },
            {
                imageName:'Girl and Guard close up', 
                imagePath:'/assets/images/projects/time-to-talk/girl-guard-closeup.png',
                imageDescription:'What Ben noticed from the edge of the rooftop'
            },
            {
                imageName:'Girl and guard enter alleyway', 
                imagePath:'/assets/images/projects/time-to-talk/girl-guard-enter.png',
                imageDescription:'A longshot of the girl and the guard entering the alleyway.'
            },
            {
                imageName:'Ben has made a decision', 
                imagePath:'/assets/images/projects/time-to-talk/headlinelook.png',
                imageDescription:'Ben has made a decision of what he should do after seeing something suspicious. You\'ll have to play the game to see what he does.'
            },
            {
                imageName:'Ben looking at his phone', 
                imagePath:'/assets/images/projects/time-to-talk/lookatphone.png',
                imageDescription:'Ben is looking at his phone for something. I tried making a dynamic angle of him looking at his phone.'
            },
            {
                imageName:'Phone close up', 
                imagePath:'/assets/images/projects/time-to-talk/phonecloseup.png',
                imageDescription:'What is Ben seeing on his phone.'
            },
            {
                imageName:'Police chase', 
                imagePath:'/assets/images/projects/time-to-talk/policeChaseFinalDraw-here.png',
                imageDescription:'Ben sees a police chase speed across the city while people watching.'
            },
            {
                imageName:'The rooftop', 
                imagePath:'/assets/images/projects/time-to-talk/roofTop.png',
                imageDescription:'Where Ben finds himself at the begining of the game.'
            },
            {
                imageName:'Security Job Posting', 
                imagePath:'/assets/images/projects/time-to-talk/securityjobad.png',
                imageDescription:'A security job found if you play as Dan.'
            },
            {
                imageName:'Security Job Posting 2', 
                imagePath:'/assets/images/projects/time-to-talk/securityjobad2.png',
                imageDescription:'Another security job found if you play as Dan.'
            },
            {
                imageName:'Security office', 
                imagePath:'/assets/images/projects/time-to-talk/securityoffice.png',
                imageDescription:'A security office you get if you play as Dan.'
            },
            {
                imageName:'Job discussion', 
                imagePath:'/assets/images/projects/time-to-talk/spritejob-discuss_cafestill.png',
                imageDescription:'Daniel is discussing a potential job with Aitor.'
            },
            {
                imageName:'Thinking about the potential job', 
                imagePath:'/assets/images/projects/time-to-talk/spritejobreaction.png',
                imageDescription:'Daniel is trying to picture what this new job would be like. Because he has no frame of reference.'
            },
            {
                imageName:'Wizard cops', 
                imagePath:'/assets/images/projects/time-to-talk/workwithothersorcerers.png',
                imageDescription:'Would Daniel work as a wizard cop???'
            },
        ]
    },
    {
        label:'Periwinkle Gob', 
        path:'/pages/original-projects/periwinkle-gob',
        component:'Periwinkle',
        previewimage:[
            {
                imageName:'Periwinkle Gob', 
                imagePath:'/assets/images/projects/dndchar/dnd-Periwinkle.jpg',
                projectPath:'/pages/original-projects/periwinkle-gob',
            }
        ],
        projectimages:[
            {
                imageName:'Periwinkle Gob', 
                imagePath:'/assets/images/projects/dndchar/dnd-Periwinkle.jpg',
                imageDescription:'This is my dnd character. He goes by Peri. I\'ll need to look at the character card for more info to put here.'
            },
        ]
    },
]